import React from "react";
import thumbImage from "../../assets/images/icons/thumb.svg";
import avatar from "../../assets/images/avatar.svg";

class ResultSideBar extends React.Component {
  render() {
    const props = this.props;

    let rightWords = props.rightWords;
    let wrongWords = props.wrongWords;
    return (
      <div className="bg-g-theme l-6  resultSideBar">
        <div
          className={`headerText ${
            props.isRightSideBar ? "headerTextWrong" : ""
          }`}
        >
          <p className="text">
            <img
              src={thumbImage}
              style={props.isRightSideBar ? { transform: "scaleY(-1)" } : {}}
              alt=""
            />
            {props.isRightSideBar ? "WRONG" : "RIGHT"}
          </p>
        </div>
        {rightWords ? (
          <div className="scrollView">
            {rightWords &&
              rightWords.length > 0 &&
              rightWords.map((rightWord) => {
                let userOfWord = props.gameData.roomObj.users.find(
                  (user) => user.player_id === rightWord.player_id
                );
                let imgToShow = avatar;
                if (userOfWord && Object.keys(userOfWord).length > 0) {
                  if (userOfWord && userOfWord.profile_image) {
                    imgToShow = userOfWord.profile_image;
                  }
                }

                return (
                  <div className="player text-uppercase">
                    <span className="word" title={rightWord.word}>
                      {rightWord.word}
                    </span>
                    <span className="profile">
                      <img src={imgToShow} alt="" />
                    </span>
                  </div>
                );
              })}
          </div>
        ) : (
          <div className="scrollView">
            {wrongWords &&
              wrongWords.length > 0 &&
              wrongWords.map((wrongWord) => {
                let userOfWord = props.gameData.roomObj.users.find(
                  (user) => user.player_id === wrongWord.player_id
                );
                let imgToShow = avatar;
                if (userOfWord && Object.keys(userOfWord).length > 0) {
                  if (userOfWord && userOfWord.profile_image) {
                    imgToShow = userOfWord.profile_image;
                  }
                }
                return (
                  <div className="player text-uppercase">
                    <span className="word" title={wrongWord.word}>
                      {wrongWord.word}
                    </span>
                    <span className="profile">
                      <img src={imgToShow} alt="" />
                    </span>
                  </div>
                );
              })}
          </div>
        )}
      </div>
    );
  }
}
export default ResultSideBar;
